import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getStatusColor(status) {
  const colors = {
    submitted: 'bg-amber-100 text-amber-700',
    passed: 'bg-emerald-100 text-emerald-700',
    failed: 'bg-red-100 text-red-700',
    needs_revision: 'bg-sky-100 text-sky-700',
    active: 'bg-emerald-100 text-emerald-700',
    completed: 'bg-[#D4AF37]/20 text-[#D4AF37]',
    pending: 'bg-amber-100 text-amber-700',
  };
  return colors[status] || 'bg-slate-100 text-slate-700';
}

export function getProgressColor(progress) {
  if (progress >= 100) return 'bg-gradient-to-r from-[#D4AF37] to-[#F4E08F]';
  if (progress >= 75) return 'bg-gradient-to-r from-[#41EAD4] to-[#1B3A4B]';
  if (progress >= 50) return 'bg-[#41EAD4]';
  if (progress >= 25) return 'bg-[#1B3A4B]';
  return 'bg-slate-400';
}

export function truncateText(text, maxLength = 100) {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
}

export function isAdmin(role) {
  return ['super_admin', 'instructor', 'reviewer'].includes(role);
}

export function isSuperAdmin(role) {
  return role === 'super_admin';
}

export function canGrade(role) {
  return ['super_admin', 'instructor', 'reviewer'].includes(role);
}
